// Third party libraries, not Foundation specific.
import 'slick-carousel/slick/slick';

// collapses content within columns into slides which can be scrolled through horizontally on mobile devices

const slickSliderContent = () => {
    $(document).ready(() => {
        const sliderDiv = $('.slider-content__slides');

        if (sliderDiv.length > 0) {
            // default slider to show 1 slide on small and 3 slides on medium and large
            // most content scrollers will only have 3 slides,
            // see /_src/markup/frontier/geo-state.hbs for an example with 5 slides
            let numSlidesToShowSmall = 1;
            let numSlidesToShowMedium = 3;
            let numSlidesToShowLarge = 3;

            // allow for data attributes for showing number of slides per breakpoint
            if (sliderDiv.data('slides-to-show-small')) {
                numSlidesToShowSmall = sliderDiv.data('slides-to-show-small');
            }

            if (sliderDiv.data('slides-to-show-medium')) {
                numSlidesToShowMedium = sliderDiv.data('slides-to-show-medium');
            }

            if (sliderDiv.data('slides-to-show-large')) {
                numSlidesToShowLarge = sliderDiv.data('slides-to-show-large');
            }

            sliderDiv.slick({
                dots: true,
                slidesToShow: numSlidesToShowLarge,
                slidesToScroll: 1,
                // slide: '.slider-content__slide',
                prevArrow:
                    '<svg class="slider-content__previous-arrow"><use xlink:href="#previous-arrow"></use></svg>',
                nextArrow:
                    '<svg class="slider-content__next-arrow"><use xlink:href="#next-arrow"></use></svg>',
                responsive: [
                    {
                        breakpoint: 960,
                        settings: {
                            slidesToShow: numSlidesToShowMedium,
                        },
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: numSlidesToShowSmall,
                        },
                    },
                ],
            });
        }
    });
};

// Module startup
const init = () => {
    slickSliderContent();
};

export { init };
